

























import {Component, Mixins} from 'vue-property-decorator';
import DatePicker from '@/components/input/DatePicker.vue';
import FilterMixin from '@/components/table/filter/FilterMixin';
import CommonButton from '@/components/button/CommonButton.vue';
import UserApi from '@/api/UserApi';
import {CommonModelUtils, Filter, FilterRetrieveResponse} from '@/model/CommonModel';
import TextInput from '@/components/input/TextInput.vue';
import CaseDateTimePicker from '@/components/input/CaseDateTimePicker.vue';
import DateTimePicker from '@/components/input/DateTimePicker.vue';

@Component({
  components: {DateTimePicker, CaseDateTimePicker, TextInput, DatePicker, CommonButton}
})
export default class DateRangeFilter extends Mixins<FilterMixin>(FilterMixin) {
  private startDate: string = '';
  private endDate: string = '';
  private readonly defaultBetweenFilter: Filter = {
    selected: '',
    filterType: 'BETWEEN_DATE_TIME',
    valueCode: '',
    valueCode2: '',
    valueLabel: ''
  };

  public loadFilter() {
    this.loading = true;
    UserApi.retrieveUserFilters(this.menuId, this.tableHeader.columnId)
        .then((res: FilterRetrieveResponse) => {
          const filterListElement: Filter
              = CommonModelUtils.getOrDefault(res.data, {filterList: [this.defaultBetweenFilter]}).filterList[0];
          this.startDate = filterListElement.valueCode as string;
          this.endDate = filterListElement.valueCode2 as string;
        })
        .finally(() => {
          this.loading = false;
          (this.$refs.endDate as any).focus();
          (this.$refs.startDate as any).focus();
        });
  }

  public onDone() {
    const startDate: any = this.$refs.startDate;
    startDate.hide();

    const endDate: any = this.$refs.endDate;
    endDate.hide();

    this.getFilterPromise(this.startDate, this.endDate)
        .then((res: any) => {
          this.visible = false;
          this.$emit('refresh');
        });
  }

  protected getFilterPromise(startDate: string, endDate: string) {
    if (!startDate && !endDate) {
      return UserApi.deleteUserFilters(this.menuId, this.tableHeader.columnId);
    } else {
      return UserApi.updateUserFilters(this.menuId, this.tableHeader.columnId, [{
        filterType: 'BETWEEN_DATE_TIME',
        valueCode: startDate ?? '',
        valueCode2: endDate ?? ''
      }]);
    }
  }

  public onStartDateShow() {
    const endDate: any = this.$refs.endDate;
    endDate.hide();
  }

  public onEndDateShow() {
    const startDate: any = this.$refs.startDate;
    startDate.hide();
  }
}
